import { createElement } from 'react';
import type { LucideProps } from 'lucide-react';
import { resolveLucideIcon } from '../../../utils/lucideIconCatalog';

export type LiksLucideIconProps = LucideProps & {
  name?: string | null;
};

export function LiksLucideIcon({ name, ...iconProps }: LiksLucideIconProps) {
  return createElement(resolveLucideIcon(name), iconProps);
}
